import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_getLoyality, api_getLoyalityByFilter } from '../../api/loyality'; // Adjusted import for Loyality APIs
import Input from '../../components/bootstrap/forms/Input';
import Icon from '../../components/icon/Icon';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../layout/SubHeader/SubHeader';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';

const PAGE_SIZE = 5;

const Item = ({ item, removeLoyalityFromTable, index }: any) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	return (
		<tr key={index}>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.user?.name}</div>{' '}
						{/* Display loyality name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.user?.phoneNumber}</div>{' '}
						{/* Display loyality name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.date}</div>{' '}
						{/* Display loyality name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.reason}</div>{' '}
						{/* Display loyality name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.status}</div>{' '}
						{/* Display loyality name */}
					</div>
				</div>
			</td>
			<td>
				<span
					onClick={() => navigate(`/edit/loyality`, { state: item })} // Navigate to edit event type route
					style={{
						margin: 10,
						cursor: 'pointer',
						display: item?.status === 'active' ? 'inline' : 'none',
					}}>
					EDIT
				</span>
			</td>
		</tr>
	);
};

const AllLoyality = () => {
	const [loyalitys, setLoyalitys] = useState<any>([]); // State variable to hold loyalitys
	const [loading, setLoading] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();
	const tableBodyRef = useRef<HTMLTableSectionElement>(null);
	const [filter, setFilter] = useState(false);
	const [searchString, setSearchString] = useState('');

	// Function to fetch loyalitys
	const getLoyalitys = async (page_no?: number) => {
		const finalPageNo = page_no || pageNo;

		try {
			setLoading(true);
			const res = await api_getLoyality(finalPageNo, PAGE_SIZE); // Fetch loyalitys from API

			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					if (page_no === 1) {
						setLoyalitys(res.data);
						setPageNo(2);
					} else {
						setLoyalitys([...loyalitys, ...res.data]);
						setPageNo(pageNo + 1);
					}
				}
			} else {
				console.error('Failed to fetch loyality:', res.message);
			}
		} catch (error) {
			console.error('Error fetching loyality:', error);
		} finally {
			setLoading(false);
		}
	};
	const getLoyalitysByFilter = async () => {
		try {
			setLoading(true);
			const res = await api_getLoyalityByFilter(searchString);
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				setLoyalitys(res.data);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	// Function to remove loyality from table
	const removeLoyalityFromTable = (loyalityId: string) => {
		setLoyalitys(loyalitys.filter((e: any) => e._id !== loyalityId));
	};

	// Load more loyalitys
	const onLoadMore = () => {
		if (hasMore) {
			getLoyalitys();
		}
	};

	// Handle filter reset
	const handleFilterReset = () => {
		setLoyalitys([]);
		setHasMore(true);
		getLoyalitys(1);
	};

	// Fetch loyalitys on component mount
	useEffect(() => {
		getLoyalitys();
	}, []);

	// Add scroll event listener to table body
	useEffect(() => {
		tableBodyRef.current?.addEventListener('scroll', (e) => {
			console.log(e);
		});
	}, []);

	return (
		<PageWrapper title={'Event Types'}>
			<div style={{ marginTop: '20px' }}>
				<SubHeader>
					<SubHeaderLeft>
						<label
							className='border-0 bg-transparent cursor-pointer me-0'
							htmlFor='searchInput'>
							<Icon
								icon='Search'
								size='2x'
								color='primary'
								onClick={() => {
									setLoyalitys([]);
									setHasMore(true);
									getLoyalitysByFilter();
								}}
							/>
						</label>
						<Input
							value={searchString}
							onChange={(e: any) => setSearchString(e?.target?.value)}
							id='searchInput'
							type='search'
							className='border-0 shadow-none bg-transparent'
							placeholder='Search Loyal Customers...'
						/>
					</SubHeaderLeft>
				</SubHeader>
			</div>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>All Loyal Customers</CardTitle>
					</CardLabel>
					{/* <CardActions>
						<Button
							onClick={() => navigate('/add/loyality')}
							icon='PersonAdd'
							color='primary'
							isLight={true}>
							New Loyality
						</Button>
					</CardActions> */}
				</CardHeader>
				<CardBody isScrollable className='table-responsive'>
					<table className='table table-modern'>
						<thead>
							<tr>
								<th>Customer Name</th>
								<th>Phone No.</th>
								<th>Date</th>
								<th>Reason</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{loyalitys?.map((item: any, index: any) => (
								<Item
									key={index}
									item={item}
									index={index}
									removeLoyalityFromTable={removeLoyalityFromTable}
								/>
							))}
						</tbody>
					</table>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginBottom: '20px',
						}}>
						{hasMore && (
							<button
								style={{
									border: 'none',
									padding: '10px',
									borderRadius: '10px',
									cursor: 'pointer',
								}}
								onClick={onLoadMore}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllLoyality;
